export default __webpack_public_path__ + "static/media/repair-design.bffad954.jpeg";